import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../providers/api";

const initialState = { tasks: 0, isLoading: true };

export const getTasks = createAsyncThunk("get-tasks", async () => {
  const response = await api.taskCenter.getTasksCount();
  return response?.Data?.Tasks;
});

const notificationSlice = createSlice({
  name: "tasks",
  initialState,
  extraReducers: {
    [getTasks.fulfilled]: (state, action) => {
      state.tasks = action.payload;
      state.isLoading = false;
    },
    [getTasks.pending]: (state) => {
      state.isLoading = true;
    },
    [getTasks.rejected]: (state) => {
      state.isLoading = false;
      // addToast.error("error", {
      //   toastId: "error",
      // });
    },
  },
});

export default notificationSlice.reducer;
